module.exports = __webpack_public_path__ + "static/media/textonly.04907bbf.png";